export default "__VITE_ASSET__CQuLzKvO__"